import React from 'react';
import HeroContent from './HeroContent';
import ScrollIndicator from '../../common/ScrollIndicator';
import '../../../styles/components/sections/Hero.css';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="hero-overlay"></div>
      <HeroContent />
      <ScrollIndicator />
    </section>
  );
};

export default Hero;